<div class="pageNotFound flex flex-col justify-center items-center space-y-3  "
>
  <app-image
    [loaderTheme]="{
             'height': '100%',
             'width': '100%'
            }"
    [url]="'/assets/images/png/pageNotFound.png'"
    class="image-container"
  ></app-image>
  <div class="text"> OOPS!...</div>
  <div class="text-message text-cool-grey">The page you were looking for doesn't
    exist
  </div>
  <app-primary-button
    class="back-button"
    type="small"
    (handleClick)="homepage()"
  >
    Go back
  </app-primary-button>
</div>
